import { selectProjectHasIntegrations } from "Reducers/project/project/project.selectors";
import { loadOneProject } from "Reducers/project/project/thunks/loadOneProject.thunk";
import { startAppListening } from "Store/listenerMiddleware";

import { getIntegrations, selectHasLoadedIntegrationsForProject } from ".";

import type { AppStartListening } from "Store/listenerMiddleware";

/**
 * Loads the project integrations once the project itself is loaded, so the
 * project and environment overview cards can show the git repository without
 * the components fetching on mount.
 *
 * Gated on the project's `#integrations` link: the backend decides which roles
 * can list integrations, and users without the link would only get a 403.
 */
export const registerIntegrationListeners = (
  startListening: AppStartListening
) => {
  startListening({
    actionCreator: loadOneProject.fulfilled,
    effect: (action, { dispatch, getState }) => {
      const { organizationId, projectId } = action.meta.arg;
      const state = getState();

      if (!selectProjectHasIntegrations(state, { organizationId, projectId }))
        return;

      // Integration create/update/delete keep the slice in sync; a project
      // reload does not need to refetch the list.
      if (selectHasLoadedIntegrationsForProject(state, { projectId })) return;

      dispatch(getIntegrations({ projectId }));
    }
  });
};

// Register against the production middleware singleton.
registerIntegrationListeners(startAppListening);
